import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Writing({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-5.5 -4.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g className={theme.stroke} fill="none" fillRule="evenodd">
        <g strokeLinecap="round" strokeLinejoin="round">
          <path d="M10.97936377 25.0963775v-4.7038652L25.0673638 6.55117715V1.37027467H8.61936377v7.15434929H1.35844069L1.33751762 29.5444928H25.0673638V15.9595123l-9.3003077 9.1368652zM1.33720992 8.5245635l7.28184616-7.1543493-7.28184616 7.1543493z" />
          <path d="M8.61911762 1.37015374l-7.26092308 7.1543493h7.26092308z" />
        </g>
        <path d="M25.1368407 6.55540942l-.0455385.04413652 4.7507693 4.66819327.0455384-.04474114z" />
        <path d="M32.2155484 7.2397674l-2.9870769-2.93538121c-.4984616-.48912943-1.3027693-.48912943-1.8006154 0l-2.2910769 2.25096277 4.7507692 4.66758865-.0449231.04474113.0363077.0362766 2.3366154-2.2957039c.4978461-.48912943.4978461-1.27935461 0-1.76848404zM25.0914253 6.59972733l.0455385-.04413653-.0701539-.00423227L10.97942531 20.392089v4.7044699h4.78769229l9.2996923-9.1374699 4.7753846-4.69116841z" />
      </g>
    </svg>
  )
}

Writing.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
